import React from 'react';
import '../css/Hero.css';

function Hero() {
  return (
    <section id="top" className="hero">
      <div className="hero-overlay">
        <div className="hero-content">
          <h1>Aevolt Everflow</h1>
          <p className="hero-text">
            Store energy for your home, protect against outages and keep life
            moving with a compact home battery.
          </p>
        </div>

        <div className="hero-bottom">
          <div className="hero-stats">
            <div>
              <strong>Up to 15 kWh</strong>
              <span>Energy Capacity</span>
            </div>
            <div>
              <strong>Up to 6  kW</strong>
              <span>Continuous Power</span>
            </div>
            <div>
              <strong>2 Years</strong>
              <span>Warranty</span>
            </div>
          </div>

          <div className="hero-buttons">
            <a href="#order" className="primary-btn">Order Now</a>
            <a href="#specs" className="secondary-btn">View Specs</a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
